module.exports = __webpack_public_path__ + "img/vende_tu_auto_paso3_mobile.e7af2c39.png";